import { render, staticRenderFns } from "./KonzessionsThemaCard.vue?vue&type=template&id=0181f37e&scoped=true&"
import script from "./KonzessionsThemaCard.vue?vue&type=script&lang=js&"
export * from "./KonzessionsThemaCard.vue?vue&type=script&lang=js&"
import style0 from "./KonzessionsThemaCard.vue?vue&type=style&index=0&id=0181f37e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0181f37e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VCol,VIcon,VRow})
